import React from 'react'
import { Menu } from 'antd'
import { MessageOutlined, WechatOutlined, LogoutOutlined, ScheduleOutlined, CarOutlined } from '@ant-design/icons'
import * as Constants from '../../../constants'
import './styles.css'

const { SubMenu } = Menu;

const MainMenuEmployee = ({ onItemClick, itemSelected, user }) => {
    return (
        <Menu className="MainMenuCont" theme="dark" defaultSelectedKeys={[itemSelected]} mode="horizontal">
            {/*<Menu.Item key={`/`} onClick={() => {
                onItemClick({ itemClickType: Constants.MenuEmployee.CHAT })
            }}>
                <MessageOutlined/>
                <span>Chat</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuEmployee.HISTORICAL_CHAT}`} onClick={() => {
                onItemClick({ itemClickType: Constants.MenuEmployee.HISTORICAL_CHAT })
            }}>
                <WechatOutlined/>
                <span>Chat - Históricos</span>
            </Menu.Item> */}
            <SubMenu
            key="sub3"
            title={
                <span>
                    <ScheduleOutlined />
                    <span>Resumen</span>
                </span>
            }>
                <Menu.Item key={`/${Constants.MenuEmployee.RESUME.SD}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.RESUME.SD})}}><span>SD</span></Menu.Item>
                <Menu.Item key={`/${Constants.MenuEmployee.RESUME.ARCASA}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.RESUME.ARCASA})}}><span>Arcasa</span></Menu.Item>
            </SubMenu>
            <SubMenu
            key="sub1"
            title={
                <span>
                    <ScheduleOutlined />
                    <span>Trabajos</span>
                </span>
            }>
                <Menu.Item key={`/${Constants.MenuEmployee.WORKS.ARCASA}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.WORKS.ARCASA})}}><span>Lista Arcasa</span></Menu.Item>
                <Menu.Item key={`/${Constants.MenuEmployee.WORKS.SD}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.WORKS.SD})}}><span>Lista SD</span></Menu.Item>
                {/* <Menu.Item key={`/${Constants.MenuEmployee.WORKS.RESUME}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.WORKS.RESUME})}}><span>Resumen</span></Menu.Item> */}
                <Menu.Item key={`/${Constants.MenuEmployee.WORKS.CALENDAR}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.WORKS.CALENDAR})}}><span>Calendario</span></Menu.Item>
                <Menu.Item key={`/${Constants.MenuEmployee.WORKS.TRIPS}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.WORKS.TRIPS})}}><span>Viajes</span></Menu.Item>
            </SubMenu>
            <SubMenu
            key="sub2"
            title={
                <span>
                    <ScheduleOutlined />
                    <span>Cotizaciones</span>
                </span>
            }>
                <Menu.Item key={`/${Constants.MenuEmployee.BID.ARCASA}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.BID.ARCASA})}}><span>Cotizaciones Arcasa</span></Menu.Item>
                <Menu.Item key={`/${Constants.MenuEmployee.BID.SD}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.BID.SD})}}><span>Cotizaciones SD</span></Menu.Item>
            </SubMenu>
            <Menu.Item key={`/${Constants.MenuEmployee.OUTSOURCING}`} onClick={() => {
                onItemClick({ itemClickType: Constants.MenuEmployee.OUTSOURCING })
            }}>
                <ScheduleOutlined />
                <span>Proveedores</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuEmployee.CLIENTS}`} onClick={() => {
                onItemClick({ itemClickType: Constants.MenuEmployee.CLIENTS })
            }}>
                <ScheduleOutlined />
                <span>Clientes</span>
            </Menu.Item>
            {/* Comentado: Registros movido al menú de usuarios REGISTER
            {
                user && user.id && Constants.VALID_USERS_IDS.includes(user.id) &&
                <Menu.Item key={`/${Constants.MenuEmployee.REGISTERS}`} onClick={() => {
                    onItemClick({ itemClickType: Constants.MenuEmployee.REGISTERS })
                }}>
                    <ScheduleOutlined />
                    <span>Registros</span>
                </Menu.Item>
            }
            */}
            {
                Constants.UsersWithPermissions.includes(user.email) &&
                <Menu.Item key={`/${Constants.MenuEmployee.INVENTORY_HISTORICAL}`} onClick={() => {onItemClick({itemClickType: Constants.MenuEmployee.INVENTORY_HISTORICAL})}}>
                    <CarOutlined  />
                    <span>Movilidades - Históricos</span>
                </Menu.Item>
            }
            <Menu.Item key={`/${Constants.MenuEmployee.LOGOUT}`} onClick={() => {
                onItemClick({ itemClickType: Constants.MenuEmployee.LOGOUT })
            }}>
                <LogoutOutlined/>
                <span>Cerrar sesión</span>
            </Menu.Item>
        </Menu>
    )
}

MainMenuEmployee.propTypes = {}

export default MainMenuEmployee
